module.exports = __webpack_public_path__ + "img/geodesy_home.ab85422e.jpg";